/* eslint-disable react/prop-types */
import React from 'react';
import IconButton from '@mui/material/IconButton';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import SendIcon from '@mui/icons-material/Send';

const InputArea = ({ 
  isExpanded, 
  placeholder, 
  collapsedPlaceholder, 
  inputValue, 
  inputRef, 
  isLoading, 
  onExpand, 
  onChange, 
  onKeyDown, 
  onSend 
}) => (
  <div 
    className="ai-chat-widget-input-container" 
    onClick={!isExpanded ? onExpand : undefined}
  >
    <AutoAwesomeIcon className="input-ai-icon" />
    <input
      ref={inputRef}
      type="text"
      className="ai-chat-widget-input"
      placeholder={isExpanded ? placeholder : collapsedPlaceholder}
      value={inputValue}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onFocus={onExpand}
      disabled={isLoading}
    />
    {(inputValue.trim() || isExpanded) && (
      <IconButton
        onClick={onSend}
        disabled={!inputValue.trim() || isLoading}
        className="send-button"
        size="small"
      >
        <SendIcon fontSize="small" />
      </IconButton>
    )}
  </div>
);

export default InputArea;

